import { render, staticRenderFns } from "./IconSortArrows.vue?vue&type=template&id=b9421ab4"
import script from "./IconSortArrows.vue?vue&type=script&lang=js"
export * from "./IconSortArrows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports